import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as styles from "../tanks.module.scss";
import AreaView from '../area/area_view.jsx';
import { selectAreas } from '../../../state/selectors/tanks';
import tankService from '../../../services/tanksService';
import { AccessLevel, AppModules } from '../../../constants/appAccess';
import ModuleAccess from '../../../components/access/module_access';

const TanksList = ({ history }) => {
    const areas = useSelector(selectAreas());

    useEffect(() => {
        getData();
    },
        []);

    const getData = () => {
        tankService.getAreasAsync();
    }

    const addArea = () => {
        history.push('/tanks/addArea');
    }

    const addTank = (areaId) => {
        history.push('/tanks/' + areaId + "/addTank/");
    }

    const selectTank = (tank) => {
        history.push('/tanks/tankdetails/' + tank.tankId);
    }

    //editTank(tank) {
    //    history.push('/tanks/editTank/' + tank.tankId);
    //}

    return (
        <div>
            <div className={styles.tanks_page_header}>
                <div className={styles.right_buttons_container}>
                    <ModuleAccess access={AccessLevel.Write} moduleName={AppModules.Areas}>
                        <button className={styles.add_item_button} onClick={addArea}></button>
                    </ModuleAccess>

                </div>
            </div>

            <div className={styles.tanks_page_body}>
                {
                    areas.map((item, index) => {
                        return (<div key={index}>
                            <AreaView area={item} selectTankFunction={selectTank} addTankFunction={addTank} />
                        </div>);
                    })
                }
            </div>
        </div>
    );
}

//<Table settings={{
//    columns: Columns,
//    items: tanks,
//    itemsFilter: filter,
//    isEditable: true,
//    getItemsFunction: getData,
//    addItemFunction: addTank,
//    editItemFunction: editTank
//}} />

export default TanksList;